<template>
  <div class="booked-seats">
    <div
      v-for="(seats, key) in booked_seats"
      :key="`${_uid}:seats:${key}`"
      class="booked-seats__item"
    >
      <div class="d-flex flex-column" style="gap: 5px">
        <em>
          {{ formatSegmentLabel(segments_map[key], true) }}
        </em>
        <div class="d-flex flex-column" style="gap: 2px">
          <span
            v-for="seat in seats"
            :key="`seat:${key}:${seat.seatNumber}`"
            v-b-popover.hover.top="seat.traveler_name || `P${seat.travelerId}`"
            class="booked-seats__traveler-seat"
          >
            <span> {{ seat.traveler_name || `P${seat.travelerId}` }}: </span>
            <span class="semibold">
              {{ seat.seatNumber }}
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  formatSegmentLabel,
  seats_per_segment,
  getSegmentsFromFlightOffers,
} from "@liveflight/utilities";
export default {
  name: "booked-seats",
  props: {
    flight_offer: {
      type: Object,
      required: true,
    },
    travelers: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    segments_map() {
      return getSegmentsFromFlightOffers([this.flight_offer]);
    },
    traveler_details() {
      try {
        return this.travelers.map((e) => ({
          ...e,
          ...(e.name || {}),
        }));
      } catch (e) {
        this.log("booked-seats.traveler_details");
        this.log(e);
        return [];
      }
    },
    booked_seats() {
      return seats_per_segment(this.flight_offer, this.traveler_details);
    },
  },
  methods: {
    formatSegmentLabel,
  },
};
</script>

<style lang="scss" scoped>
.booked-seats {
  margin-top: $grid-gutter-20;

  &__item {
    display: flex;
    gap: $grid-gutter-width;

    &:not(:first-child) {
      border-top: 1px solid $gray-200;
      margin-top: $grid-gutter-width / 3;
      padding-top: $grid-gutter-width / 3;
    }
  }

  &__traveler-seat {
    display: flex;
    gap: $grid-gutter-width / 3;
  }
}
</style>
